import * as Preact from 'preact';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
export var Component = function (p) { return (Preact.h(Box, { sx: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        gap: '4px',
        paddingX: '6px',
        boxSizing: 'border-box',
    } },
    Preact.h(Typography, { fontSize: p.name === 'furniture.option.none' ? '14px' : '13px', fontWeight: p.name === 'furniture.option.none' ? 700 : 400, letterSpacing: 0.15 }, p.name))); };
Component.displayName = 'ProductInfo';
